import React from "react";
import SmartScanSelfieConfirm from "../../components/SmartScanSelfieConfirmPage/SmartScanSelfieConfirm";
import { smartScanCategory } from "../../constants";
import useGetSmartScanSelfieCaptureProgress from "../../components/CustomHooks/useGetSmartScanSelfieCaptureProgress";

const SmartScanLowerArchConfirm = () => {
  const smartScanState = useGetSmartScanSelfieCaptureProgress();

  return (
    <>
      <body className="mobile-body">
        <div className="body-content">
          <section className="review-photo-section py-4 py-md-5">
            {smartScanState ? (
              <SmartScanSelfieConfirm
                nextPagePath={
                  smartScanState.isAuthenticated
                    ? "/smart-scan-upper-lip"
                    : "/smart-scan-upper-lip-no-auth"
                }
                retakePagePath={
                  smartScanState.isAuthenticated
                    ? "/smart-scan-lower-arch"
                    : "/smart-scan-lower-arch-no-auth"
                }
                state={smartScanState}
                category={smartScanCategory.LowerArch}
              />
            ) : (
              <></>
            )}
          </section>
        </div>
      </body>
    </>
  );
};

export default SmartScanLowerArchConfirm;
